export default (value) => {
  let cpf = value;
  let soma = 0;
  let resto = 0;

  cpf = cpf.replace(/\D/g, '');

  // The regex matches 11 equal digits, considered not valid as CPF numbers:
  // http://normas.receita.fazenda.gov.br/sijut2consulta/anexoOutros.action?idArquivoBinario=36307
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
    return false;
  }

  for (let idx = 1; idx <= 9; idx += 1) {
    soma += parseInt(cpf.substring(idx - 1, idx), 10) * (11 - idx);
  }

  resto = (soma * 10) % 11;

  if (resto === 10 || resto === 11) {
    resto = 0;
  }

  if (resto !== parseInt(cpf.substring(9, 10), 10)) {
    return false;
  }

  soma = 0;

  for (let idx = 1; idx <= 10; idx += 1) {
    soma += parseInt(cpf.substring(idx - 1, idx), 10) * (12 - idx);
  }

  resto = (soma * 10) % 11;

  if (resto === 10 || resto === 11) {
    resto = 0;
  }

  if (resto !== parseInt(cpf.substring(10, 11), 10)) {
    return false;
  }

  return true;
};
